// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonFields = {
  id: "ID",
  userId: "ユーザーID",
  username: "ユーザー名",
  displayName: "表示名称",
  role: "ロール",
  status: "状態",
  type: "種別",
  examId: "試験 ID",
  attemptId: "受験 ID",
  module: "モジュール",
  action: "アクション",
  resource: "リソース",
  resourceType: "リソース種別",
  resourceId: "リソース ID",
  relation: "関連",
  sequenceNo: "問題番号",
  order: "順序",
  limit: "件数",
  difficulty: "難易度",
  code: "コード",
  identifier: "識別子",
  name: "名称",
  description: "説明",
  title: "タイトル",
  organization: "組織",
  organizationUnit: "組織ユニット",
  phone: "携帯番号",
  expiresAt: "有効期限",
  platformRoles: "プラットフォームロール",
  applicationRolesSummary: "アプリロール概要",
  organizationMemberships: "組織所属",
  platformRoleAssignments: "プラットフォームロール付与詳細",
  paperType: "試験用紙タイプ",
  questionType: "問題タイプ",
  questionCount: "問題数",
  totalScore: "合計点",
  durationMinutes: "想定時間",
  field: "フィールド",
  fromValue: "変更前",
  toValue: "変更後",
  jsonField: "JSON フィールド",
  path: "パス",
  changeType: "変更種別",
  versionNo: "バージョン",
  versionedCode: "バージョン付きコード",
  verdict: "判定",
  judgeStatus: "採点状態",
  language: "言語",
  score: "点数",
  passedCases: "通過ケース数",
  stdout: "標準出力（stdout）",
  stderr: "標準エラー（stderr）",
  createdBy: "作成者",
  createdAt: "作成日時",
  updatedBy: "更新者",
  updatedAt: "更新日時",
  actions: "操作",
} as const;
